// extracted by mini-css-extract-plugin
export var player = "styles-module--player--2Heho";
export var content = "styles-module--content--3FdQR";
export var button = "styles-module--button--2Qmzi";
export var youtube = "styles-module--youtube--2eZi9";
export var loading = "styles-module--loading--3NzTx";